import { UtmLeadProductType } from '@enums/UtmLeadProduct'

export const autoVasConfig = {
  prod: {
    appGeneratorLink: 'https://tinyurl.internal.live.acko.com/api/v1/appflyer_deep_link/',
    apiKeySem: {
      [UtmLeadProductType.SEM_CHALLAN]: 'c1imWcVFVTEW2W',
      [UtmLeadProductType.PMAX_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.META_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.SEM_FASTAG]: 'E4ieWcLIJTEZ8S',
    },
    apiChallanKeyWithouUtm: 's7imWcVPATEZ5A',
    apiFastagKeyWithoutUtm: 'f4imWcFNATEZ4F',
  },
  master: {
    appGeneratorLink: 'https://tinyurl.internal.ackodev.com/api/v1/appflyer_deep_link/',
    apiKeySem: {
      [UtmLeadProductType.SEM_CHALLAN]: 'c1imWcVFVTEW2A',
      [UtmLeadProductType.PMAX_CHALLAN]: 'c10eWSLKfTEZ3x',
      [UtmLeadProductType.META_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.SEO_CHALLAN]: 's7imWcVPATEZ5B',
      [UtmLeadProductType.SEM_FASTAG]: 'f7ieWcLBKTEZ6F',
    },
    apiChallanKeyWithouUtm: 's7imWcVPATEZ5B',
    apiFastagKeyWithoutUtm: 'f4imWcFNATEZ4C',
  },
  dev: {
    appGeneratorLink: 'https://tinyurl.internal.ackodev.com/api/v1/appflyer_deep_link/',
    apiKeySem: {
      [UtmLeadProductType.SEM_CHALLAN]: 'c1imWcVFVTEW2A',
      [UtmLeadProductType.PMAX_CHALLAN]: 'c10eWSLKfTEZ3x',
      [UtmLeadProductType.META_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.SEM_FASTAG]: 'f7ieWcLBKTEZ6F',
    },
    apiChallanKeyWithouUtm: 's7imWcVPATEZ5B',
    apiFastagKeyWithoutUtm: 'f4imWcFNATEZ4C',
  },
  local: {
    appGeneratorLink: 'https://tinyurl.internal.ackodev.com/api/v1/appflyer_deep_link/',
    apiKeySem: {
      [UtmLeadProductType.SEM_CHALLAN]: 'c1imWcVFVTEW2W',
      [UtmLeadProductType.PMAX_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.META_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.SEM_FASTAG]: 'E4ieWcLIJTEZ8S',
    },
    apiChallanKeyWithouUtm: 's7imWcVPATEZ5B',
    apiFastagKeyWithoutUtm: 'f4imWcFNATEZ4C',
  },
}
